import { render } from "./SignInForm.vue?vue&type=template&id=2a905a20&scoped=true"
import script from "./SignInForm.vue?vue&type=script&lang=js"
export * from "./SignInForm.vue?vue&type=script&lang=js"

import "./SignInForm.vue?vue&type=style&index=0&id=2a905a20&lang=sass&scoped=true"

import exportComponent from "../../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a905a20"]])

export default __exports__